export const MILITAO_URL =
  import.meta.env.VITE_MILITAO_URL ||
  `https://${import.meta.env.VITE_VERCEL_BRANCH_URL}`
export const LUKITA_URL = import.meta.env.VITE_LUKITA_URL
export const COURTOIS_URL = import.meta.env.VITE_COURTOIS_URL
// The in-app help surface streams answers from the website-v2 help bot and reads
// article bodies from it. It lives on the marketing site origin, so it falls back
// to COURTOIS_URL when VITE_HELP_BOT_URL is unset.
export const HELP_BOT_URL =
  import.meta.env.VITE_HELP_BOT_URL || import.meta.env.VITE_COURTOIS_URL
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY
export const STRIPE_CUSTOMER_PORTAL_URL = import.meta.env
  .VITE_STRIPE_CUSTOMER_PORTAL_URL
export const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST
export const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY
export const MAPBOX_KEY = import.meta.env.VITE_MAPBOX_KEY
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN

export const DEFAULT_ITEMS_PER_PAGE = 10
export const DEFAULT_CURRENT_PAGE = 1
export const WEBSOCKETS_URL = import.meta.env.VITE_WEBSOCKETS_URL
export const SUPPORT_URL = `${COURTOIS_URL}/contact`
// The casemiro support ticketing service (REST + SSE).
export const SUPPORT_SERVICE_URL = import.meta.env.VITE_SUPPORT_URL

export const OUTAGE_BANNER_CONFIG = {
  bannerEnabled: import.meta.env.VITE_OUTAGE_BANNER_ENABLED === 'true',
  bannerMessage: import.meta.env.VITE_OUTAGE_BANNER_MESSAGE ?? '',
  bannerSeverity: import.meta.env.VITE_OUTAGE_BANNER_SEVERITY,
} as const

export const DISABLE_PROCESSING =
  import.meta.env.VITE_PROCESSING_DISABLED === 'true'

// True only on the production deploy (app.counselpro.ai). Gates
// customer-facing features that should stay hidden on local dev and
// preview/staging URLs.
export const IS_PRODUCTION = import.meta.env.VITE_VERCEL_ENV === 'production'
